import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import Utility from "../../../shared/utility";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import exportLimit from "../../common/export-limit.vue";
import reportingService from "./reporting-service";
import moment from "moment";

export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      isAllProjectSelected: false,
      runDisabled: true,
      isAllBusinessSelected: false,
      isAllWarehouseSelected: false,
      isAllParentClassSelected: false,
      isAllClassSelected: false,
      showEndDate: false,
      showData: false,
      pageUrl: "",
      route: "",
      showAdd: false,
      refresh: true,
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      projectList: [],
      partResultList: [],
      reportData: [],
      warehouseList: [],
      businessList: [],
      parentClassList: [],
      classList: [],
      shipMethodList: [],
      debouncedGetPartList: [],
      required: [(v) => parseInt(v) >= 0 || "Field is required"],
      requiredText: [(v) => !!v || "Field is required"],
      showPart: true,
      hideSpecific: false,
      disableAll: false,
      specificSelected: false,
      disableSpecific: false,
      showPartNumDetails: false,
      showPartDetails: false,
      partNum: "",
      partSearchKey: "",
      totalRecords: 0,
      partDesc: "",
      showRestDetails: false,
      reportObj: {
        proj_key: "",
        bu_key: "",
        ware_key: "",
        parent_class_key: "",
        class_key: "",
        ship_method: "",
        all_stock: false,
        all_usage: false,
        lcedate: new Date(new Date().getTime() - 86400000)
          .toISOString()
          .substr(0, 10),
        user_id: EncryptUtility.localStorageDecrypt("userID"),
      },
      reportHeader: [
        {
          text: "Project",
          align: "start",
          value: "Project",
          class: "primary customwhite--text",
        },
        {
          text: "Business",
          align: "start",
          value: "Business",
          class: "primary customwhite--text",
        },
        {
          text: "Warehouse",
          align: "start",
          value: "Warehouse",
          class: "primary customwhite--text",
        },
        {
          text: "Item",
          align: "start",
          value: "Item",
          class: "primary customwhite--text",
        },
        {
          text: "OEM_PartNo",
          align: "start",
          value: "OEM_PartNo",
          class: "primary customwhite--text",
        },
        {
          text: "Description",
          align: "start",
          value: "Description",
          class: "primary customwhite--text",
        },
        {
          text: "Parent Class",
          align: "start",
          value: "PClass",
          class: "primary customwhite--text",
        },
        {
          text: "Class",
          align: "start",
          value: "Class",
          class: "primary customwhite--text",
        },
        {
          text: "Model",
          align: "start",
          value: "Model",
          class: "primary customwhite--text",
        },
        {
          text: "OEM",
          align: "start",
          value: "OEM",
          class: "primary customwhite--text",
        },
        {
          text: "Aloc",
          align: "start",
          value: "Aloc",
          class: "primary customwhite--text",
        },
        {
          text: "BO",
          align: "start",
          value: "BO",
          class: "primary customwhite--text",
        },
        {
          text: "Aval",
          align: "start",
          value: "Aval",
          class: "primary customwhite--text",
        },
        {
          text: "FGI",
          align: "start",
          value: "FGI",
          class: "primary customwhite--text",
        },
        {
          text: "RO_Pnt",
          align: "start",
          value: "RO_Pnt",
          class: "primary customwhite--text",
        },
        {
          text: "AvgToFGI_RunRate",
          align: "start",
          value: "AvgToFGI_RunRate",
          class: "primary customwhite--text",
        },
        {
          text: "AvgShpd_RunRate",
          align: "start",
          value: "AvgShpd_RunRate",
          class: "primary customwhite--text",
        },
        {
          text: "30_Day_To_FGI",
          align: "start",
          value: "Day_TO_FGI_30",
          class: "primary customwhite--text",
        },
        {
          text: "60_Day_To_FGI",
          align: "start",
          value: "Day_TO_FGI_60",
          class: "primary customwhite--text",
        },
        {
          text: "90_Day_To_FGI",
          align: "start",
          value: "Day_TO_FGI_90",
          class: "primary customwhite--text",
        },
        {
          text: "120_Day_To_FGI",
          align: "start",
          value: "Day_TO_FGI_120",
          class: "primary customwhite--text",
        },
        {
          text: "30_Day_Shpd",
          align: "start",
          value: "Day_Shpd_30",
          class: "primary customwhite--text",
        },
        {
          text: "60_Day_Shpd",
          align: "start",
          value: "Day_Shpd_60",
          class: "primary customwhite--text",
        },
        {
          text: "90_Day_Shpd",
          align: "start",
          value: "Day_Shpd_90",
          class: "primary customwhite--text",
        },
        {
          text: "120_Day_Shpd",
          align: "start",
          value: "Day_Shpd_120",
          class: "primary customwhite--text",
        },
      ],
    };
  },
  async created(){
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.debouncedGetPartList = Utility.debounce(this.getPartList, 500);
    this.getProjectData();
    this.finalReportObj = JSON.parse(JSON.stringify(this.reportObj));
  },
  computed: {
    processedProjectList() {
      // Assumes project items have a 'value_id' property and 'ALL' is 0
      return this.createProcessedList(
        this.projectList,
        this.isAllProjectSelected,
        "value_id",
        0
      );
    },
    processedBusinessList() {
      // IMPORTANT: Adjust 'bu_key' if your business items use a different ID property name.
      // Adjust the last argument (0) if your 'ALL' business option has a different value.
      return this.createProcessedList(
        this.businessList,
        this.isAllBusinessSelected,
        "bu_key",
        0
      );
    },
    processedWarehouseList() {
      return this.createProcessedList(
        this.warehouseList,
        this.isAllWarehouseSelected,
        "ware_key",
        0
      );
    },
    processedParentClassList() {
      return this.createProcessedList(
        this.parentClassList,
        this.isAllParentClassSelected,
        "parent_class_key",
        0
      );
    },
    procressedClassList() {
      return this.createProcessedList(
        this.classList,
        this.isAllClassSelected,
        "class_key",
        0
      );
    },
    lceDateFormattedMomentjs() {
      return this.reportObj.lcedate
        ? moment(String(this.reportObj.lcedate)).format("MM/DD/YYYY")
        : "";
    },
    excelFileName() {
      return Utility.excelFileName("Sales Order Run Rate");
    },
  },
  methods: {
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    async getProjectData() {
      let projectData = await reportingService.getReportingGenericProjectList(
        "get",
        this.userId
      );
      if (projectData !== undefined && projectData !== null) {
        this.projectList = projectData;
      } else {
        this.projectList = [];
      }
    },
    actionSetter(action) {
      if (
        this.actionList !== undefined &&
        this.actionList !== null &&
        this.actionList !== ""
      ) {
        let filter = this.actionList.filter(
          (entry) => entry.SystemName === action
        );
        return filter !== undefined && filter !== null && filter?.length == 1
          ? true
          : false;
      } else return false;
    },
    createProcessedList(
      list,
      isAllSelected,
      idKey = "value_id",
      allValueId = 0
    ) {
      // Use optional chaining ?. in case the list is initially null/undefined
      return (
        list?.map((item) => ({
          ...item,
          // Disable the item if the 'isAllSelected' flag is true AND the item's ID is not the 'ALL' ID
          disabled: isAllSelected && item[idKey] !== allValueId,
        })) || []
      ); // Return an empty array if the input list is null/undefined
    },


    /**
     * Handles the common logic for multi-select components where an "ALL" option exists.
     * Updates the corresponding reportObj key and the isAllSelected flag.
     * @param {Array} selectedKeys - The array of selected keys from the component.
     * @param {string} reportObjKey - The key in this.reportObj to update (e.g., 'proj_key').
     * @param {string} isAllSelectedFlagKey - The key in this data for the boolean flag (e.g., 'isAllProjectSelected').
     * @param {number|string} [allValueId=0] - The value representing the "ALL" option.
     */
    handleSelectionChange(
      selectedKeys,
      reportObjKey,
      isAllSelectedFlagKey,
      allValueId = 0
    ) {
      const userSelectedAll = selectedKeys.includes(allValueId);
      const wasOnlyAllSelected = this[isAllSelectedFlagKey]; // Get previous state
      if (userSelectedAll) {
        // If "ALL" is selected (newly or with others), force selection to *only* "ALL"
        // Or if user just clicked "ALL" when it was already the only selection
        if (!wasOnlyAllSelected || selectedKeys?.length > 1) {
          this.reportObj[reportObjKey] = [allValueId];
        }
        this[isAllSelectedFlagKey] = true;
      } else {
        // User selected specific items or deselected "ALL"
        this[isAllSelectedFlagKey] = false;
      }
    },

    onChangeProject(selectedKeys) {
      this.handleSelectionChange(
        selectedKeys,
        "proj_key",
        "isAllProjectSelected",
        0
      );

      // Reset dependent lists and flags when project changes
      this.businessList = [];
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.bu_key = [];
      this.reportObj.ware_key = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.reportObj.ship_method = "";
      this.disableAll = false;
      this.clearPartShip();
      this.specificSelected = false;
      this.showPart = true;
      this.isAllBusinessSelected = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.reportData= [];
      this.totalRecords = 0;
      this.isAllClassSelected = false;
      this.showRestDetails = false;
      // Prepare and call the next API
      let businessObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
      };
      if (this.reportObj.proj_key && this.reportObj.proj_key?.length > 0) {
        this.getBusinessData(businessObj);
      }
      this.showData=false;
      this.disableAll = false;
      this.hideSpecific = false;
    },

    async getBusinessData(businessObj) {
      let businessData =
        await reportingService.getReportingGenericBusinessList(
          "post",
          businessObj
        );
      if (businessData && Array.isArray(businessData)) {
        this.businessList = businessData;
      } else {
        this.businessList = [];
      }
    },

    onChangeBusiness(selectedKeys) {
      this.handleSelectionChange(
        selectedKeys,
        "bu_key",
        "isAllBusinessSelected",
        0
      );

      // Reset dependent lists and flags
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.ware_key = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      this.isAllClassSelected = false;
      this.reportData= [];
      this.totalRecords = 0;
      this.showRestDetails = false;
      // Prepare and call the next API
      let warehouseObj = {
        execution_type: 1,
        proj_key: this.reportObj.proj_key?.toString(),
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.bu_key && this.reportObj.bu_key?.length > 0) {
        this.getWarehouseData(warehouseObj);
      }
    },

    async getWarehouseData(warehouseObj) {
      let warehouseData =
        await reportingService.getReportingGenericWarehouseList(
          "post",
          warehouseObj
        );
      if (warehouseData && Array.isArray(warehouseData)) {
        this.warehouseList = warehouseData;
      } else {
        this.warehouseList = [];
      }
    },

    onChangeWarehouse(selectedKeys) {
      this.handleSelectionChange(
        selectedKeys,
        "ware_key",
        "isAllWarehouseSelected",
        0
      );

      // Reset dependent lists and flags
      this.parentClassList = [];
      this.classList = [];
      this.reportObj.parent_class_key = [];
      this.reportObj.class_key = [];
      this.isAllParentClassSelected = false;
      this.isAllClassSelected = false;
      this.reportData= [];
      this.totalRecords = 0;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      this.showRestDetails = false;
      // Prepare and call the next API
      let parentClassObj = {
        execution_type: 1,
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (this.reportObj.ware_key && this.reportObj.ware_key?.length > 0) {
        this.getParentClassData(parentClassObj);
      }
    },

    async getParentClassData(parentClassObj) {
      let parentClassData =
        await reportingService.getReportingGenericParentClassList(
          "post",
          parentClassObj
        );
      if (parentClassData && Array.isArray(parentClassData)) {
        this.parentClassList = parentClassData;
      } else {
        this.parentClassList = [];
      }
    },

    onChangeParentClass(selectedKeys) {
      this.handleSelectionChange(
        selectedKeys,
        "parent_class_key",
        "isAllParentClassSelected",
        0
      );
      // Reset dependent lists and flags
      this.classList = [];
      this.reportObj.class_key = [];
      this.isAllClassSelected = false;
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      this.clearPartShip();
      this.showRestDetails = false;
      // Prepare and call the next API
      let classObj = {
        execution_type: 1,
        user_id: this.userId,
        bu_key: this.reportObj.bu_key?.toString(),
      };
      if (
        this.reportObj.parent_class_key &&
        this.reportObj.parent_class_key?.length > 0
      ) {
        this.getClassData(classObj);
      }
    },

    async getClassData(classObj) {
      let classData = await reportingService.getReportingGenericClassList(
        "post",
        classObj
      );
      if (classData && Array.isArray(classData)) {
        this.classList = classData;
      } else {
        this.classList = [];
      }
    },

    async onChangeClass(selectedKeys) {
      this.handleSelectionChange(
        selectedKeys,
        "class_key",
        "isAllClassSelected",
        0
      );
      this.shipMethodList = [];    
      this.reportObj.ship_method = "";
      this.specificSelected = false;
      this.showPart = true;
      let shipData = await reportingService.getGenericShipmentList(
        "get",
        this.userId
      );
      this.clearPartShip();
      this.showRestDetails = false;
      if (shipData && Array.isArray(shipData)) {
        this.shipMethodList = shipData;
      } else {
        this.shipMethodList = [];
      }
      this.reportData= [];
      this.totalRecords = 0;
    },
    onClickSpecificPartNumber() {
      this.specificSelected = true;
    },
    async searchPartNum() {
      if (this.partSearchKey?.length > 2) {
        this.debouncedGetPartList();
      }
    },
    async getPartList() {
      this.showPartNumDetails = true;
      let SearchObj = {
        user_id: this.userId,
        search_str: this.partSearchKey,
        proj_key: this.reportObj.proj_key?.toString(),
      };
      let partResultData = await reportingService.showPartNumDetailsData(
        "post",
        SearchObj,
        false
      );
      this.partResultList = partResultData?.Resultset;
    },

    async showPartDesc(item) {
      this.showPartDetails = true;
      this.showRestDetails = true;
      this.partNum = item.PartNo;
      this.partDesc = item.Description;
      this.partSearchKey = item.PartNo;
      this.showPartNumDetails = false;
      this.reportObj.part_num = this.partNum;
    },
    clearPartShip() {
      this.showPartDetails = false;
      this.showRestDetails = false;
      this.partSearchKey = "";
      this.partResultList = [];
      this.partNum = "";
      this.partDesc = "";
    },
    async onClickRunReport() {
      if (this.$refs.reportForm.validate()) {
        this.finalReportObj.proj_key = this.reportObj.proj_key?.toString();
        this.finalReportObj.bu_key = this.reportObj.bu_key?.toString();
        this.finalReportObj.ware_key = this.reportObj.ware_key?.toString();
        this.finalReportObj.parent_class_key =
          this.reportObj.parent_class_key?.toString();
        this.finalReportObj.class_key = this.reportObj.class_key?.toString();
        this.finalReportObj.ship_method =
          this.reportObj.ship_method?.toString();
        this.finalReportObj.lcedate = Utility.inputDateFormat(this.lceDateFormattedMomentjs,"23:59:59");
        this.finalReportObj.all_stock = this.reportObj.all_stock ? 1 : 0;
        this.finalReportObj.all_usage = this.reportObj.all_usage ? 1 : 0;
        this.finalReportObj.part_num = this.reportObj.part_num;
        this.reportData = await reportingService.getSalesOrderRunRateReport(
          "post",
          this.finalReportObj
        );
        if (this.reportData?.length > 0) {
          this.showData = true;
          this.totalRecords = this.reportData.length;
        }
        else{
          Utility.showNoDataToast("No Data Available");
        }
      } else {
        Utility.validateForm("reportForm", this);
       
      }
    },
    resetFunction() {
      // Reset the report object to its initial state
      this.reportObj = {
        proj_key: [], // Use [] for multi-select, or initial value
        bu_key: [],
        ware_key: [],
        parent_class_key: [],
        class_key: [],
        ship_method: [],
        all_stock: false,
        all_usage: false,
        lcedate: new Date(new Date().getTime() - 86400000)
          .toISOString()
          .substr(0, 10), // Or null/default
        user_id: this.userId, // Keep user_id
        part_num: "", // Reset part num if used
      };
      // Reset dependent lists and flags
      this.businessList = [];
      this.warehouseList = [];
      this.parentClassList = [];
      this.classList = [];
      this.shipMethodList = []; // Reset ship method list if needed
      this.isAllProjectSelected = false;
      this.isAllBusinessSelected = false;
      this.isAllWarehouseSelected = false;
      this.isAllParentClassSelected = false;
      this.hideSpecific = true;
      this.specificSelected = false;
      this.partSearchKey = "";
      this.isAllClassSelected = false;
      this.showPart = true;
      this.showPartDetails = false;
      this.hideSpecific = false;
      this.disableAll = false;
      // Reset part search state
      this.clearPartShip();
      // Reset validation state
      this.$refs.reportForm.resetValidation();
      // Hide results
      this.showData = false;
      this.reportData = [];
      this.totalRecords = 0;
      this.runDisabled = true;
      // Re-fetch initial data if necessary (like projects)
      this.getProjectData();
    },
    onClickAll(){
      this.showRestDetails = true;
      this.hideSpecific=true;
     this.reportObj.part_num = "0";
    },
    onChangeAllUsage(){
      if (this.reportObj.all_usage) {
        this.reportObj.all_stock = false;
      }

    },
    onChangeAllStock() {
      if (this.reportObj.all_stock) {
        this.reportObj.all_usage = false;
      }
    },
    // ... other methods ...
  },
  components: {
    breadcrumbComp,
    BackToTop,
    exportLimit,
  },
};
